var TextStyle_TextAlignment = /* @__PURE__ */ ((TextStyle_TextAlignment2) => {
  TextStyle_TextAlignment2["AUTO"] = "AUTO";
  TextStyle_TextAlignment2["LEFT"] = "LEFT";
  TextStyle_TextAlignment2["RIGHT"] = "RIGHT";
  TextStyle_TextAlignment2["CENTER"] = "CENTER";
  TextStyle_TextAlignment2["JUSTIFY"] = "JUSTIFY";
  TextStyle_TextAlignment2["UNRECOGNIZED"] = "UNRECOGNIZED";
  return TextStyle_TextAlignment2;
})(TextStyle_TextAlignment || {});
var Link_Target = /* @__PURE__ */ ((Link_Target2) => {
  Link_Target2["SELF"] = "SELF";
  Link_Target2["BLANK"] = "BLANK";
  Link_Target2["PARENT"] = "PARENT";
  Link_Target2["TOP"] = "TOP";
  Link_Target2["UNRECOGNIZED"] = "UNRECOGNIZED";
  return Link_Target2;
})(Link_Target || {});
var PluginContainerData_Alignment = /* @__PURE__ */ ((PluginContainerData_Alignment2) => {
  PluginContainerData_Alignment2["CENTER"] = "CENTER";
  PluginContainerData_Alignment2["LEFT"] = "LEFT";
  PluginContainerData_Alignment2["RIGHT"] = "RIGHT";
  PluginContainerData_Alignment2["UNRECOGNIZED"] = "UNRECOGNIZED";
  return PluginContainerData_Alignment2;
})(PluginContainerData_Alignment || {});
var PluginContainerData_Width_Type = /* @__PURE__ */ ((PluginContainerData_Width_Type2) => {
  PluginContainerData_Width_Type2["CONTENT"] = "CONTENT";
  PluginContainerData_Width_Type2["SMALL"] = "SMALL";
  PluginContainerData_Width_Type2["ORIGINAL"] = "ORIGINAL";
  PluginContainerData_Width_Type2["FULL_WIDTH"] = "FULL_WIDTH";
  PluginContainerData_Width_Type2["UNRECOGNIZED"] = "UNRECOGNIZED";
  return PluginContainerData_Width_Type2;
})(PluginContainerData_Width_Type || {});
var Gradient_Type = /* @__PURE__ */ ((Gradient_Type2) => {
  Gradient_Type2["LINEAR"] = "LINEAR";
  Gradient_Type2["RADIAL"] = "RADIAL";
  Gradient_Type2["UNRECOGNIZED"] = "UNRECOGNIZED";
  return Gradient_Type2;
})(Gradient_Type || {});
export {
  Gradient_Type,
  Link_Target,
  PluginContainerData_Alignment,
  PluginContainerData_Width_Type,
  TextStyle_TextAlignment
};
//# sourceMappingURL=common.enums.js.map
